;(function () {
  'use strict';

  var STATES = {
    EMAIL_GATE: 'EMAIL_GATE',
    PRE_GAME: 'PRE_GAME',
    PLAYING: 'PLAYING',
    GAME_OVER: 'GAME_OVER'
  };

  var CLAW_PHASES = {
    IDLE: 'IDLE',
    DROPPING: 'DROPPING',
    GRABBING: 'GRABBING',
    RETRACTING: 'RETRACTING'
  };

  var ITEM_TYPES = {
    EGG: 'egg',
    GIFT: 'gift',
    BOMB: 'bomb'
  };

  var STORAGE_KEYS = {
    TOKEN: 'hcg2_token',
    NAME: 'hcg2_name',
    EMAIL: 'hcg2_email',
    HIGH_SCORE: 'hcg2_high_score',
    RANKINGS_SCORE: 'hcg2_rankings_score'
  };

  var roots = Array.prototype.slice.call(document.querySelectorAll('.hc-easter-game-2'));
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (!root || root.__hcg2Mounted) return;
    root.__hcg2Mounted = true;

    var config = {
      workersUrl: root.getAttribute('data-workers-url') || '',
      campaignStart: root.getAttribute('data-campaign-start') || '',
      campaignEnd: root.getAttribute('data-campaign-end') || '',
      heading: root.getAttribute('data-heading') || 'Egg Catcher',
      subheading: root.getAttribute('data-subheading') || '',
      rulesText: root.getAttribute('data-rules-text') || '',
      gameDuration: parseInt(root.getAttribute('data-game-duration'), 10),
      clawSpeed: parseFloat(root.getAttribute('data-claw-speed')),
      bombRate: parseFloat(root.getAttribute('data-bomb-rate')),
      spawnInterval: parseInt(root.getAttribute('data-spawn-interval'), 10),
      voucherCollectionHandle: root.getAttribute('data-voucher-collection-handle') || '',
      voucherNote: root.getAttribute('data-voucher-note') || '',
      tabs: [
        { handle: root.getAttribute('data-tab-1-handle') || '', label: root.getAttribute('data-tab-1-label') || '' },
        { handle: root.getAttribute('data-tab-2-handle') || '', label: root.getAttribute('data-tab-2-label') || '' },
        { handle: root.getAttribute('data-tab-3-handle') || '', label: root.getAttribute('data-tab-3-label') || '' },
        { handle: root.getAttribute('data-tab-4-handle') || '', label: root.getAttribute('data-tab-4-label') || '' },
        { handle: root.getAttribute('data-tab-5-handle') || '', label: root.getAttribute('data-tab-5-label') || '' }
      ].filter(function (t) { return t.handle && t.label; }),
      tier1Min: parseInt(root.getAttribute('data-tier-1-min'), 10),
      tier1Code: root.getAttribute('data-tier-1-code') || '',
      tier1Label: root.getAttribute('data-tier-1-label') || 'Tier 1 Discount',
      tier1Pct: parseInt(root.getAttribute('data-tier-1-pct'), 10),
      tier2Min: parseInt(root.getAttribute('data-tier-2-min'), 10),
      tier2Code: root.getAttribute('data-tier-2-code') || '',
      tier2Label: root.getAttribute('data-tier-2-label') || 'Tier 2 Discount',
      tier2Pct: parseInt(root.getAttribute('data-tier-2-pct'), 10),
      tier3Min: parseInt(root.getAttribute('data-tier-3-min'), 10),
      tier3Code: root.getAttribute('data-tier-3-code') || '',
      tier3Label: root.getAttribute('data-tier-3-label') || 'Tier 3 Discount',
      tier3Pct: parseInt(root.getAttribute('data-tier-3-pct'), 10),
      tier4Min: parseInt(root.getAttribute('data-tier-4-min'), 10),
      tier4Code: root.getAttribute('data-tier-4-code') || '',
      tier4Label: root.getAttribute('data-tier-4-label') || 'Tier 4 Discount',
      tier4Pct: parseInt(root.getAttribute('data-tier-4-pct'), 10),
      tier5Min: parseInt(root.getAttribute('data-tier-5-min'), 10),
      tier5Code: root.getAttribute('data-tier-5-code') || '',
      tier5Label: root.getAttribute('data-tier-5-label') || 'Tier 5 Discount',
      tier5Pct: parseInt(root.getAttribute('data-tier-5-pct'), 10),
      debug: (root.getAttribute('data-debug') || 'off').toLowerCase(),
      clawSprite: root.getAttribute('data-claw-sprite') || '',
      eggSprite: root.getAttribute('data-egg-sprite') || '',
      giftSprite: root.getAttribute('data-gift-sprite') || '',
      bombSprite: root.getAttribute('data-bomb-sprite') || '',
      bgImage: root.getAttribute('data-bg-image') || '',
      textStartsLabel: root.getAttribute('data-text-starts-label') || 'Game Starts In',
      textStartsMsg: root.getAttribute('data-text-starts-msg') || 'The campaign is opening soon.',
      textEndedLabel: root.getAttribute('data-text-ended-label') || 'Campaign Has Ended',
      textEndedMsg: root.getAttribute('data-text-ended-msg') || 'Thanks for playing.',
      textActiveBarLabel: root.getAttribute('data-text-active-bar-label') || 'Campaign Ends In'
    };

    if (!config.gameDuration || config.gameDuration <= 0) config.gameDuration = 30;
    if (!config.clawSpeed || config.clawSpeed <= 0) config.clawSpeed = 150;
    if (isNaN(config.bombRate) || config.bombRate < 0) config.bombRate = 20;
    if (config.bombRate > 80) config.bombRate = 80;
    config.bombRate = config.bombRate / 100;
    if (!config.spawnInterval || config.spawnInterval <= 0) config.spawnInterval = 1500;

    var els = {
      timer: root.querySelector('[data-hcg2-timer]'),
      timerLabel: root.querySelector('[data-hcg2-timer-label]'),
      timerMsg: root.querySelector('[data-hcg2-timer-msg]'),
      timerDays: root.querySelector('[data-hcg2-days]'),
      timerHours: root.querySelector('[data-hcg2-hours]'),
      timerMins: root.querySelector('[data-hcg2-mins]'),
      timerSecs: root.querySelector('[data-hcg2-secs]'),
      activeCountdown: root.querySelector('[data-hcg2-active-countdown]'),
      activeEndD: root.querySelector('[data-hcg2-end-d]'),
      activeEndH: root.querySelector('[data-hcg2-end-h]'),
      activeEndM: root.querySelector('[data-hcg2-end-m]'),
      activeEndS: root.querySelector('[data-hcg2-end-s]'),
      gameBody: root.querySelector('[data-hcg2-game-body]'),
      emailForm: root.querySelector('[data-hcg2-email-form]'),
      nameInput: root.querySelector('[data-hcg2-name]'),
      emailInput: root.querySelector('[data-hcg2-email]'),
      emailSubmit: root.querySelector('[data-hcg2-email-submit]'),
      highPregame: root.querySelector('[data-hcg2-high]'),
      rankingsPregame: root.querySelector('[data-hcg2-rankings]'),
      scoreHud: root.querySelector('[data-hcg2-score]'),
      highHud: root.querySelector('[data-hcg2-high-hud]'),
      gameTimerHud: root.querySelector('[data-hcg2-game-timer]'),
      hud: root.querySelector('[data-hcg2-hud]'),
      canvas: root.querySelector('[data-hcg2-canvas]'),
      overlayStart: root.querySelector('[data-hcg2-overlay="start"]'),
      overlayCountdown: root.querySelector('[data-hcg2-overlay="countdown"]'),
      overlayGameover: root.querySelector('[data-hcg2-overlay="gameover"]'),
      countdownNum: root.querySelector('[data-hcg2-countdown]'),
      overlayScore: root.querySelector('[data-hcg2-overlay-score]'),
      canvasStartBtn: root.querySelector('[data-hcg2-canvas-start]'),
      canvasRetryBtn: root.querySelector('[data-hcg2-canvas-retry]'),
      tapHint: root.querySelector('[data-hcg2-tap-hint]'),
      finalScore: root.querySelector('[data-hcg2-final-score]'),
      finalHigh: root.querySelector('[data-hcg2-final-high]'),
      finalTotal: root.querySelector('[data-hcg2-final-total]'),
      finalRankings: root.querySelector('[data-hcg2-final-rankings]'),
      rewardsList: root.querySelector('[data-hcg2-rewards-list]'),
      goRewardsWrap: root.querySelector('[data-hcg2-go-rewards-wrap]'),
      goRewardsList: root.querySelector('[data-hcg2-go-rewards-list]'),
      productsSection: root.querySelector('[data-hcg2-products]'),
      productsTitle: root.querySelector('[data-hcg2-products-title]'),
      productsCodeRow: root.querySelector('[data-hcg2-products-code-row]'),
      productsCodeEl: root.querySelector('[data-hcg2-products-code]'),
      copyCodeBtn: root.querySelector('[data-hcg2-copy-code]'),
      productsViewport: root.querySelector('[data-hcg2-products-viewport]'),
      overlayReward: root.querySelector('[data-hcg2-overlay-reward]'),
      overlayHint: root.querySelector('[data-hcg2-overlay-hint]'),
      productsGrid: root.querySelector('[data-hcg2-products-grid]'),
      productsTabs: root.querySelector('[data-hcg2-products-tabs]'),
      productsDots: root.querySelector('[data-hcg2-products-dots]'),
      productsPrev: root.querySelector('[data-hcg2-products-prev]'),
      productsNext: root.querySelector('[data-hcg2-products-next]'),
      claimProductBtn: root.querySelector('[data-hcg2-claim-product]'),
      lbList: root.querySelector('[data-hcg2-lb-list]'),
      lbPlayer: root.querySelector('[data-hcg2-lb-player]'),
      lbNote: root.querySelector('[data-hcg2-lb-note]'),
      lbSection: root.querySelector('[data-hcg2-lb-section]'),
      infoSide: root.querySelector('[data-hcg2-info-side]')
    };

    if (!els.canvas) return;

    var ctx = els.canvas.getContext('2d');
    if (!ctx) return;

    var state = {
      appState: STATES.EMAIL_GATE,
      currentScore: 0,
      displayScore: 0,
      highScore: 0,
      rankingsScore: 0,
      playerRank: null,
      playerName: '',
      playerEmail: '',
      playerToken: '',
      gameRemaining: config.gameDuration,
      gameRunning: false,
      gameOverTriggered: false,
      shouldStopLoop: false,
      pendingVoucherTier: null,
      newlyUnlockedTier: null,
      pendingVoucherCode: '',
      pendingVoucherExpiresAt: '',
      productsCache: [],
      selectedProductVariantId: '',
      selectedDiscountCode: '',
      selectedDiscountPercent: 0,
      leaderboardLoaded: false,
      productsEmbla: null,
      firstSpawnDone: false,
      sprites: {},
      canvasWidth: 0,
      canvasHeight: 0,
      spawnCooldown: 0,
      itemIdCounter: 1,
      items: [],
      floatingTexts: [],
      lastSpawnedTypes: [],
      catchFlash: { active: false, x: 0, y: 0, timer: 0, color: '#166534', radius: 0 },
      screenShake: { active: false, intensity: 0, timer: 0 },
      bombFlash: { active: false, timer: 0 },
      nowMs: Date.now(),
      lastFrameTime: 0,
      resizeObserver: null,
      rafId: 0,
      statusTimerId: 0,
      campaignTimerId: 0,
      countdownTimerId: 0,
      activeCampaignState: 'ACTIVE'
    };

    var claw = {
      x: 0,
      y: 0,
      startY: 30,
      dir: 1,
      phase: CLAW_PHASES.IDLE,
      grabbingTimer: 0,
      dropProgress: 0,
      carrying: null,
      pendingCatchResolution: null,
      width: 56,
      height: 56,
      tipOffsetY: 30,
      cableTopY: 0,
      dropSpeed: 480,
      retractSpeed: 500,
      boundsMinX: 40,
      boundsMaxX: 360,
      maxDropY: 280
    };

    var voucherTiers = buildVoucherTiers();

    function debugLog() {
      if (config.debug === 'off') return;
      if (!window.console || !console.log) return;
      try {
        console.log.apply(console, arguments);
      } catch (e) {
        console.log(arguments[0]);
      }
    }

    function parseET(str) {
      if (!str) return null;
      var parts = str.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
      if (!parts) return null;
      var utcNow = new Date();
      var etNow = new Date(utcNow.toLocaleString('en-US', { timeZone: 'America/New_York' }));
      var offsetMs = utcNow.getTime() - etNow.getTime();
      var target = new Date(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], 0);
      return new Date(target.getTime() + offsetMs);
    }

    function pad2(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function formatCountdown(ms) {
      if (ms <= 0) {
        return { days: '00', hours: '00', mins: '00', secs: '00' };
      }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400);
      s = s % 86400;
      var h = Math.floor(s / 3600);
      s = s % 3600;
      var m = Math.floor(s / 60);
      s = s % 60;
      return {
        days: pad2(d),
        hours: pad2(h),
        mins: pad2(m),
        secs: pad2(s)
      };
    }

    var campaignStart = parseET(config.campaignStart);
    var campaignEnd = parseET(config.campaignEnd);

    function getCampaignState() {
      var now = Date.now();
      if (campaignStart && now < campaignStart.getTime()) return 'NOT_STARTED';
      if (campaignEnd && now > campaignEnd.getTime()) return 'ENDED';
      return 'ACTIVE';
    }

    function renderTimerState(campaignState) {
      state.activeCampaignState = campaignState;
      if (!els.timer) return;

      if (campaignState === 'NOT_STARTED') {
        els.timer.hidden = false;
        els.timer.classList.remove('hc-eg2__timer--ended');
        if (els.gameBody) els.gameBody.hidden = true;
        if (els.timerLabel) els.timerLabel.textContent = config.textStartsLabel;
        if (els.timerMsg) els.timerMsg.textContent = config.textStartsMsg;
        if (els.activeCountdown) els.activeCountdown.hidden = true;
      } else if (campaignState === 'ENDED') {
        els.timer.hidden = false;
        els.timer.classList.add('hc-eg2__timer--ended');
        if (els.gameBody) els.gameBody.hidden = true;
        if (els.timerLabel) els.timerLabel.textContent = config.textEndedLabel;
        if (els.timerMsg) els.timerMsg.textContent = config.textEndedMsg;
        if (els.activeCountdown) els.activeCountdown.hidden = true;
        if (els.lbSection) {
          els.lbSection.hidden = false;
          if (!state.leaderboardLoaded && config.workersUrl) {
            if (els.lbNote) els.lbNote.textContent = 'Loading...';
            apiLeaderboard('')
              .then(function (data) {
                renderLeaderboard(data);
                state.leaderboardLoaded = true;
              })
              .catch(function () {
                renderLeaderboard(null);
              });
          }
        }
      } else {
        els.timer.hidden = true;
        if (els.gameBody) els.gameBody.hidden = false;
        if (els.activeCountdown) {
          els.activeCountdown.hidden = false;
          var activeLabel = els.activeCountdown.querySelector('.hc-eg2__active-bar-label');
          if (activeLabel) activeLabel.textContent = config.textActiveBarLabel;
          els.activeCountdown.setAttribute('aria-label', config.textActiveBarLabel);
        }
      }
    }

    function tickCampaignTimer() {
      var campaignState = getCampaignState();
      var now = Date.now();
      var diff;
      var c;
      var endDiff;
      var ec;

      if (campaignState === 'NOT_STARTED' && campaignStart) {
        diff = campaignStart.getTime() - now;
        c = formatCountdown(diff);
        if (els.timerDays) els.timerDays.textContent = c.days;
        if (els.timerHours) els.timerHours.textContent = c.hours;
        if (els.timerMins) els.timerMins.textContent = c.mins;
        if (els.timerSecs) els.timerSecs.textContent = c.secs;
        if (diff <= 0) {
          renderTimerState('ACTIVE');
          return;
        }
      }

      if (campaignState === 'ACTIVE' && campaignEnd) {
        endDiff = campaignEnd.getTime() - now;
        if (endDiff <= 0) {
          renderTimerState('ENDED');
          return;
        }
        ec = formatCountdown(endDiff);
        if (els.activeEndD) els.activeEndD.textContent = ec.days;
        if (els.activeEndH) els.activeEndH.textContent = ec.hours;
        if (els.activeEndM) els.activeEndM.textContent = ec.mins;
        if (els.activeEndS) els.activeEndS.textContent = ec.secs;
      }
    }

    var hasCampaignTimer = campaignStart || campaignEnd;
    if (hasCampaignTimer) {
      var initialCampaignState = getCampaignState();
      renderTimerState(initialCampaignState);
      state.campaignTimerId = setInterval(tickCampaignTimer, 1000);
      tickCampaignTimer();
      if (initialCampaignState !== 'ACTIVE') {
        return;
      }
    }

    function preloadSprites(urls, callback) {
      var loaded = 0;
      var total = Object.keys(urls).filter(function (k) { return urls[k]; }).length;
      if (total === 0) {
        callback({});
        return;
      }
      var sprites = {};
      Object.keys(urls).forEach(function (key) {
        if (!urls[key]) return;
        var img = new Image();
        img.onload = function () {
          sprites[key] = img;
          loaded++;
          if (loaded >= total) callback(sprites);
        };
        img.onerror = function () {
          loaded++;
          if (loaded >= total) callback(sprites);
        };
        img.src = urls[key];
      });
    }

    function clamp(v, min, max) {
      if (v < min) return min;
      if (v > max) return max;
      return v;
    }

    function toIntOr(value, fallback) {
      var n = parseInt(value, 10);
      return isNaN(n) ? fallback : n;
    }

    function normalizeTier(index, minScore, code, label, pct) {
      var min = toIntOr(minScore, 0);
      var percent = toIntOr(pct, 0);
      if (min < 0) min = 0;
      if (percent < 0) percent = 0;
      if (percent > 100) percent = 100;
      return {
        index: index,
        minScore: min,
        code: String(code || '').replace(/^\s+|\s+$/g, ''),
        label: String(label || ('Tier ' + index + ' Discount')).replace(/^\s+|\s+$/g, ''),
        discountPercent: percent
      };
    }

    function buildVoucherTiers() {
      var list = [
        normalizeTier(1, config.tier1Min, config.tier1Code, config.tier1Label, config.tier1Pct),
        normalizeTier(2, config.tier2Min, config.tier2Code, config.tier2Label, config.tier2Pct),
        normalizeTier(3, config.tier3Min, config.tier3Code, config.tier3Label, config.tier3Pct),
        normalizeTier(4, config.tier4Min, config.tier4Code, config.tier4Label, config.tier4Pct),
        normalizeTier(5, config.tier5Min, config.tier5Code, config.tier5Label, config.tier5Pct)
      ];

      list.sort(function (a, b) {
        if (a.minScore === b.minScore) return a.index - b.index;
        return a.minScore - b.minScore;
      });

      return list;
    }

    function getCurrentBestTier(score) {
      var achieved = toIntOr(score, 0);
      var best = null;
      var i;
      for (i = 0; i < voucherTiers.length; i++) {
        if (voucherTiers[i].code && achieved >= voucherTiers[i].minScore) {
          best = voucherTiers[i];
        }
      }
      return best;
    }

    function getNewlyUnlockedTier(previousHigh, currentHigh) {
      var beforeTier = getCurrentBestTier(previousHigh);
      var afterTier = getCurrentBestTier(currentHigh);
      if (!afterTier) return null;
      if (!beforeTier) return afterTier;
      if (afterTier.index > beforeTier.index) return afterTier;
      return null;
    }

    function getAllAchievedTiers(score) {
      var achieved = toIntOr(score, 0);
      var result = [];
      var i;
      for (i = 0; i < voucherTiers.length; i++) {
        if (voucherTiers[i].code && achieved >= voucherTiers[i].minScore) {
          result.push(voucherTiers[i]);
        }
      }
      return result;
    }

    function randomRange(min, max) {
      return min + Math.random() * (max - min);
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function switchScreen(name) {
      var screens = root.querySelectorAll('[data-hcg2-screen]');
      Array.prototype.forEach.call(screens, function (s) {
        s.classList.remove('is-active');
      });
      var target = root.querySelector('[data-hcg2-screen="' + name + '"]');
      if (target) target.classList.add('is-active');
    }

    function showCanvasOverlay(name) {
      var overlays = root.querySelectorAll('[data-hcg2-overlay]');
      Array.prototype.forEach.call(overlays, function (o) {
        o.hidden = true;
      });

      if (name) {
        var target = root.querySelector('[data-hcg2-overlay="' + name + '"]');
        if (target) target.hidden = false;
      }
    }

    function startCountdown(callback) {
      var count = 3;
      if (state.countdownTimerId) {
        clearInterval(state.countdownTimerId);
        state.countdownTimerId = 0;
      }

      showCanvasOverlay('countdown');
      safeSetText(els.countdownNum, count);

      state.countdownTimerId = setInterval(function () {
        count--;
        if (count > 0) {
          safeSetText(els.countdownNum, count);
        } else if (count === 0) {
          safeSetText(els.countdownNum, 'GO!');
        } else {
          clearInterval(state.countdownTimerId);
          state.countdownTimerId = 0;
          showCanvasOverlay(null);
          if (typeof callback === 'function') {
            callback();
          }
        }
      }, 800);
    }

    function showTransientMessage(msg) {
      if (!els.tapHint) return;
      els.tapHint.textContent = msg;
      els.tapHint.classList.add('is-visible');
      if (state.statusTimerId) {
        clearTimeout(state.statusTimerId);
      }
      state.statusTimerId = setTimeout(function () {
        if (!els.tapHint) return;
        if (state.appState !== STATES.PLAYING) return;
        els.tapHint.textContent = 'Tap / Click / Space to drop claw';
      }, 1400);
    }

    function safeSetText(el, val) {
      if (!el) return;
      el.textContent = String(val);
    }

    function safeStorageGet(key) {
      try { return localStorage.getItem(key); } catch (e) { return null; }
    }

    function safeStorageSet(key, val) {
      try { localStorage.setItem(key, val); } catch (e) { /* private mode */ }
    }

    function loadStorage() {
      var hs = parseInt(safeStorageGet(STORAGE_KEYS.HIGH_SCORE), 10);
      var rs = parseInt(safeStorageGet(STORAGE_KEYS.RANKINGS_SCORE), 10);
      state.highScore = isNaN(hs) ? 0 : hs;
      state.rankingsScore = isNaN(rs) ? 0 : rs;
      state.playerToken = safeStorageGet(STORAGE_KEYS.TOKEN) || '';
      state.playerName = safeStorageGet(STORAGE_KEYS.NAME) || '';
      state.playerEmail = safeStorageGet(STORAGE_KEYS.EMAIL) || '';
    }

    function persistHighScore() {
      safeStorageSet(STORAGE_KEYS.HIGH_SCORE, String(state.highScore));
    }

    function persistRankingsScore() {
      safeStorageSet(STORAGE_KEYS.RANKINGS_SCORE, String(state.rankingsScore));
    }

    function updateScoreUI() {
      safeSetText(els.scoreHud, Math.floor(state.displayScore));
      safeSetText(els.highHud, state.highScore);
      safeSetText(els.highPregame, state.highScore);
      safeSetText(els.rankingsPregame, state.rankingsScore);
      safeSetText(els.finalHigh, state.highScore);
      safeSetText(els.finalTotal, state.rankingsScore);
      safeSetText(els.finalRankings, state.playerRank ? '#' + state.playerRank : '-');
    }

    function updateGameTimerUI() {
      var t = Math.ceil(state.gameRemaining);
      if (t < 0) t = 0;
      safeSetText(els.gameTimerHud, t);
    }

    function setAppState(nextState) {
      state.appState = nextState;
      if (els.hud) {
        els.hud.hidden = nextState !== STATES.PLAYING;
      }

      if (nextState === STATES.EMAIL_GATE) {
        switchScreen('pregame');
        showCanvasOverlay('email');
      } else if (nextState === STATES.PRE_GAME) {
        switchScreen('pregame');
        showCanvasOverlay('start');
        updatePregameBestReward();
      } else if (nextState === STATES.PLAYING) {
        switchScreen('pregame');
      } else if (nextState === STATES.GAME_OVER) {
        switchScreen('gameover');
        showCanvasOverlay('gameover');
        if (els.overlayScore) safeSetText(els.overlayScore, state.currentScore);
        if (els.overlayReward) {
          if (state.newlyUnlockedTier && state.newlyUnlockedTier.label) {
            els.overlayReward.innerHTML = '<small>THIS ROUND REWARD</small><span>' + escapeHtml(state.newlyUnlockedTier.label) + ' DISCOUNT</span>';
            els.overlayReward.hidden = false;
            if (els.overlayHint) els.overlayHint.hidden = true;
          } else {
            els.overlayReward.hidden = true;
            if (els.overlayHint) els.overlayHint.hidden = false;
          }
        }
      }
    }

    function setupCanvasSize() {
      var parent = els.canvas.parentNode;
      if (!parent) return;
      var width = parent.clientWidth;
      if (!width || width < 10) width = 320;
      var height = Math.round(width * 0.75);
      if (height < 240) height = 240;
      var dpr = window.devicePixelRatio || 1;

      els.canvas.width = width * dpr;
      els.canvas.height = height * dpr;
      els.canvas.style.width = width + 'px';
      els.canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      state.canvasWidth = width;
      state.canvasHeight = height;

      claw.startY = Math.round(height * 0.08);
      claw.y = clamp(claw.y || claw.startY, claw.startY, height);
      claw.cableTopY = 0;
      claw.boundsMinX = Math.round(width * 0.1);
      claw.boundsMaxX = Math.round(width * 0.9);
      claw.maxDropY = Math.round(height * 0.68);
      if (!claw.x) claw.x = width * 0.5;
      claw.x = clamp(claw.x, claw.boundsMinX, claw.boundsMaxX);
    }

    function setupResizeObserver() {
      if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', setupCanvasSize);
        return;
      }
      state.resizeObserver = new ResizeObserver(function () {
        setupCanvasSize();
      });
      if (els.canvas.parentNode) {
        state.resizeObserver.observe(els.canvas.parentNode);
      }
    }

    function getBeltY() {
      return Math.round(state.canvasHeight * 0.72);
    }

    function drawBackground() {
      var bg = state.sprites.bg;
      if (bg && bg.width && bg.height) {
        ctx.drawImage(bg, 0, 0, state.canvasWidth, state.canvasHeight);
      } else {
        var grd = ctx.createLinearGradient(0, 0, 0, state.canvasHeight);
        grd.addColorStop(0, '#f4fbff');
        grd.addColorStop(1, '#e9f7ea');
        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, state.canvasWidth, state.canvasHeight);

        var beltTop = Math.round(state.canvasHeight * 0.68);
        var beltHeight = state.canvasHeight - beltTop;
        ctx.fillStyle = '#e1e3e9';
        ctx.fillRect(0, beltTop, state.canvasWidth, beltHeight);
        ctx.fillStyle = '#c7cbd6';
        ctx.fillRect(0, beltTop + 8, state.canvasWidth, 6);

        var i;
        for (i = 0; i < 12; i++) {
          var w = state.canvasWidth / 12;
          var x = i * w;
          ctx.fillStyle = i % 2 ? '#d7dbe4' : '#eff1f6';
          ctx.fillRect(x, beltTop + 16, w - 2, beltHeight - 16);
        }
      }
    }

    function drawEggFallback(x, y, size) {
      ctx.save();
      ctx.translate(x, y);
      ctx.beginPath();
      ctx.fillStyle = '#ffd9e2';
      ctx.ellipse(0, 0, size * 0.72, size, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#f3aabf';
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.restore();
    }

    function drawGiftFallback(x, y, size) {
      var s = size;
      ctx.save();
      ctx.translate(x - s, y - s);
      ctx.fillStyle = '#ffd36d';
      ctx.fillRect(0, 0, s * 2, s * 2);
      ctx.fillStyle = '#f45171';
      ctx.fillRect(s * 0.84, 0, s * 0.32, s * 2);
      ctx.fillRect(0, s * 0.84, s * 2, s * 0.32);
      ctx.restore();
    }

    function drawBombFallback(x, y, size) {
      ctx.save();
      ctx.translate(x, y);
      ctx.fillStyle = '#2d3440';
      ctx.beginPath();
      ctx.arc(0, 0, size, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#505967';
      ctx.beginPath();
      ctx.arc(-size * 0.2, -size * 0.2, size * 0.35, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#6b7688';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(size * 0.3, -size * 0.7);
      ctx.lineTo(size * 0.7, -size * 1.15);
      ctx.stroke();
      ctx.restore();
    }

    function drawItem(item) {
      var sprite;
      var w = item.size * 2;
      var h = item.size * 2;

      if (item.type === ITEM_TYPES.EGG) sprite = state.sprites.egg;
      if (item.type === ITEM_TYPES.GIFT) sprite = state.sprites.gift;
      if (item.type === ITEM_TYPES.BOMB) sprite = state.sprites.bomb;

      if (sprite && sprite.width && sprite.height) {
        var sw = item.size * 3.2;
        var sh = item.size * 3.2;
        ctx.drawImage(sprite, item.x - sw / 2, item.y - sh / 2, sw, sh);
        return;
      }

      if (item.type === ITEM_TYPES.EGG) {
        drawEggFallback(item.x, item.y, item.size);
      } else if (item.type === ITEM_TYPES.GIFT) {
        drawGiftFallback(item.x, item.y, item.size * 0.95);
      } else {
        drawBombFallback(item.x, item.y, item.size);
      }
    }

    function drawItems() {
      var i;
      for (i = 0; i < state.items.length; i++) {
        drawItem(state.items[i]);
      }
    }

    function drawClawFallback(x, y) {
      ctx.save();
      ctx.translate(x, y);
      ctx.fillStyle = '#8a95a8';
      ctx.fillRect(-16, -18, 32, 24);
      ctx.strokeStyle = '#5f6b7d';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(-8, 5);
      ctx.lineTo(-16, 22);
      ctx.lineTo(-6, 18);
      ctx.moveTo(8, 5);
      ctx.lineTo(16, 22);
      ctx.lineTo(6, 18);
      ctx.stroke();
      ctx.restore();
    }

    function drawClaw() {
      var sprite = state.sprites.claw;

      ctx.strokeStyle = '#9aa4b8';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(claw.x, claw.cableTopY);
      ctx.lineTo(claw.x, claw.y - 10);
      ctx.stroke();

      if (sprite && sprite.width && sprite.height) {
        ctx.drawImage(sprite, claw.x - claw.width / 2, claw.y - claw.height / 2, claw.width, claw.height);
      } else {
        drawClawFallback(claw.x, claw.y);
      }

      if (claw.carrying) {
        var c = claw.carrying;
        c.x = claw.x;
        c.y = claw.y + 44;
        var pulse = 1 + Math.sin(state.nowMs * 0.02) * 0.05;
        var oldX = c.x;
        var oldY = c.y;
        ctx.save();
        ctx.translate(c.x, c.y);
        ctx.scale(pulse, pulse);
        c.x = 0;
        c.y = 0;
        drawItem(c);
        c.x = oldX;
        c.y = oldY;
        ctx.restore();
      }
    }

    function addFloatingText(text, x, y, color) {
      state.floatingTexts.push({
        text: text,
        x: x,
        y: y,
        opacity: 1,
        vy: 26,
        color: color || '#1f2937'
      });
    }

    function updateFloatingTexts(dt) {
      var i;
      for (i = state.floatingTexts.length - 1; i >= 0; i--) {
        var f = state.floatingTexts[i];
        f.y -= f.vy * dt;
        f.opacity -= dt * 1.5;
        if (f.opacity <= 0) {
          state.floatingTexts.splice(i, 1);
        }
      }
    }

    function drawFloatingTexts() {
      if (!state.floatingTexts.length) return;
      var i;
      ctx.font = 'bold 20px system-ui, -apple-system, sans-serif';
      ctx.textAlign = 'center';
      for (i = 0; i < state.floatingTexts.length; i++) {
        var f = state.floatingTexts[i];
        ctx.globalAlpha = clamp(f.opacity, 0, 1);
        ctx.fillStyle = f.color;
        ctx.fillText(f.text, f.x, f.y);
      }
      ctx.globalAlpha = 1;
    }

    function updateCatchFlash(dt) {
      if (!state.catchFlash.active) return;
      state.catchFlash.timer -= dt;
      state.catchFlash.radius += 120 * dt;
      if (state.catchFlash.timer <= 0) {
        state.catchFlash.active = false;
      }
    }

    function drawCatchFlash() {
      if (!state.catchFlash.active) return;
      var f = state.catchFlash;
      var alpha = clamp(f.timer / 0.35, 0, 1);
      ctx.save();
      ctx.globalAlpha = alpha * 0.5;
      ctx.fillStyle = f.color;
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.radius, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }

    function updateScreenShake(dt) {
      if (!state.screenShake.active) return;
      state.screenShake.timer -= dt;
      if (state.screenShake.timer <= 0) {
        state.screenShake.active = false;
        state.screenShake.intensity = 0;
      }
    }

    function getProgressMultiplier() {
      var progress = 1 - (state.gameRemaining / config.gameDuration);
      if (progress > 0.85) return { spawnMult: 0.6, bombBonus: 0.1 };
      if (progress > 0.67) return { spawnMult: 0.8, bombBonus: 0.05 };
      return { spawnMult: 1, bombBonus: 0 };
    }

    function chooseItemType() {
      if (config.debug === 'force_bomb' && !state.firstSpawnDone) {
        state.firstSpawnDone = true;
        return ITEM_TYPES.BOMB;
      }

      var pm = getProgressMultiplier();
      var bomb = config.bombRate + pm.bombBonus;
      if (bomb > 0.8) bomb = 0.8;
      var gift = 0.2;
      var egg = 1 - bomb - gift;
      if (egg < 0.1) {
        egg = 0.1;
        gift = 0.9 - bomb;
      }

      var excluded = null;
      var last = state.lastSpawnedTypes;
      if (last.length >= 2 && last[last.length - 1] === last[last.length - 2]) {
        excluded = last[last.length - 1];
      }

      var type;
      var attempts = 0;
      do {
        var r = Math.random();
        if (r < egg) type = ITEM_TYPES.EGG;
        else if (r < egg + gift) type = ITEM_TYPES.GIFT;
        else type = ITEM_TYPES.BOMB;
        attempts++;
      } while (type === excluded && attempts < 10);

      return type;
    }

    function spawnItem() {
      if (!state.gameRunning) return;
      if (state.items.length >= 8) return;

      var fromLeft = Math.random() > 0.5;
      var y = getBeltY() - randomRange(6, 14);
      var type = chooseItemType();
      var speed = randomRange(35, 190);
      if (Math.random() < 0.15) speed = randomRange(160, 240);
      var size = type === ITEM_TYPES.GIFT ? 20 : 18;

      state.items.push({
        id: state.itemIdCounter++,
        type: type,
        x: fromLeft ? -30 : state.canvasWidth + 30,
        y: y,
        dir: fromLeft ? 1 : -1,
        speed: speed,
        size: size
      });

      state.lastSpawnedTypes.push(type);
      if (state.lastSpawnedTypes.length > 2) state.lastSpawnedTypes.shift();
    }

    function updateItems(dt) {
      var i;
      for (i = state.items.length - 1; i >= 0; i--) {
        var item = state.items[i];
        item.x += item.dir * item.speed * dt;
        if (item.x < -60 || item.x > state.canvasWidth + 60) {
          state.items.splice(i, 1);
        }
      }

      state.spawnCooldown -= dt;
      if (state.spawnCooldown <= 0) {
        var pm = getProgressMultiplier();
        spawnItem();
        state.spawnCooldown = ((config.spawnInterval + randomRange(-400, 400)) / 1000) * pm.spawnMult;
        if (state.spawnCooldown < 0.3) state.spawnCooldown = 0.3;
      }
    }

    function findCollisionItem() {
      var tipX = claw.x;
      var tipY = claw.y + claw.tipOffsetY;
      var best = null;
      var bestDist = 999999;
      var i;
      for (i = 0; i < state.items.length; i++) {
        var item = state.items[i];
        var dx = item.x - tipX;
        var dy = item.y - tipY;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 40 && dist < bestDist) {
          best = item;
          bestDist = dist;
        }
      }
      return best;
    }

    function removeItemById(itemId) {
      var i;
      for (i = state.items.length - 1; i >= 0; i--) {
        if (state.items[i].id === itemId) {
          state.items.splice(i, 1);
          return;
        }
      }
    }

    function dropClaw() {
      if (state.appState !== STATES.PLAYING) return;
      if (!state.gameRunning) return;
      if (claw.phase !== CLAW_PHASES.IDLE) return;
      claw.phase = CLAW_PHASES.DROPPING;
      claw.dropProgress = 0;
    }

    function resolveCatchResult() {
      if (!claw.pendingCatchResolution) return;

      var result = claw.pendingCatchResolution;
      claw.pendingCatchResolution = null;

      if (result.type === ITEM_TYPES.BOMB) {
        state.screenShake = { active: true, intensity: 12, timer: 0.5 };
        state.bombFlash = { active: true, timer: 0.5 };
        state.gameRunning = false;
        addFloatingText('BOOM!', claw.x, claw.y + 20, '#cc0000');
        setTimeout(function () { triggerGameOver('bomb'); }, 600);
        return;
      }

      if (result.points > 0) {
        state.currentScore += result.points;
        if (state.currentScore > 999999) state.currentScore = 999999;
        addFloatingText('+' + result.points, claw.x, claw.y + 38, result.points >= 50 ? '#0d9488' : '#166534');
      }
    }

    function updateClaw(dt) {
      if (!state.gameRunning) return;

      if (claw.phase === CLAW_PHASES.IDLE) {
        claw.x += claw.dir * config.clawSpeed * dt;
        if (claw.x <= claw.boundsMinX) {
          claw.x = claw.boundsMinX;
          claw.dir = 1;
        } else if (claw.x >= claw.boundsMaxX) {
          claw.x = claw.boundsMaxX;
          claw.dir = -1;
        }
      } else if (claw.phase === CLAW_PHASES.DROPPING) {
        var dropRange = claw.maxDropY - claw.startY;
        if (dropRange < 1) dropRange = 1;
        claw.dropProgress = (claw.y - claw.startY) / dropRange;
        claw.dropProgress = clamp(claw.dropProgress, 0, 1);
        var dropMult = 0.6 + 0.8 * claw.dropProgress;
        claw.y += claw.dropSpeed * dropMult * dt;
        if (claw.y >= claw.maxDropY) {
          claw.y = claw.maxDropY;
          claw.phase = CLAW_PHASES.GRABBING;
          claw.grabbingTimer = 0.15;

          var hit = findCollisionItem();
          if (hit) {
            removeItemById(hit.id);
            claw.carrying = {
              id: hit.id,
              type: hit.type,
              x: hit.x,
              y: hit.y,
              dir: 0,
              speed: 0,
              size: hit.size
            };

            if (hit.type === ITEM_TYPES.EGG) {
              claw.pendingCatchResolution = { type: hit.type, points: 10 };
              state.catchFlash = {
                active: true,
                x: claw.x,
                y: claw.y + claw.tipOffsetY,
                timer: 0.35,
                color: '#166534',
                radius: 10
              };
            } else if (hit.type === ITEM_TYPES.GIFT) {
              claw.pendingCatchResolution = { type: hit.type, points: 50 };
              state.catchFlash = {
                active: true,
                x: claw.x,
                y: claw.y + claw.tipOffsetY,
                timer: 0.35,
                color: '#ca8a04',
                radius: 10
              };
            } else {
              claw.pendingCatchResolution = { type: hit.type, points: 0 };
            }
          }
        }
      } else if (claw.phase === CLAW_PHASES.GRABBING) {
        claw.grabbingTimer -= dt;
        if (claw.grabbingTimer > 0.09) {
          claw.y += 50 * dt;
        } else if (claw.grabbingTimer > 0.05) {
          claw.y -= 50 * dt;
        }
        if (claw.grabbingTimer <= 0) {
          claw.phase = CLAW_PHASES.RETRACTING;
        }
      } else if (claw.phase === CLAW_PHASES.RETRACTING) {
        var retractRange = claw.maxDropY - claw.startY;
        if (retractRange < 1) retractRange = 1;
        var retractProgress = 1 - ((claw.y - claw.startY) / retractRange);
        retractProgress = clamp(retractProgress, 0, 1);
        var retractMult = 1.3 - 0.6 * retractProgress;
        claw.y -= claw.retractSpeed * retractMult * dt;
        if (claw.y <= claw.startY) {
          claw.y = claw.startY;
          claw.phase = CLAW_PHASES.IDLE;
          claw.dropProgress = 0;
          resolveCatchResult();
          claw.carrying = null;
        }
      }
    }

    function resetRoundValues() {
      if (state.countdownTimerId) {
        clearInterval(state.countdownTimerId);
        state.countdownTimerId = 0;
      }

      state.currentScore = 0;
      state.displayScore = 0;
      state.gameRemaining = config.gameDuration;
      state.gameRunning = false;
      state.gameOverTriggered = false;
      state.pendingVoucherTier = null;
      state.newlyUnlockedTier = null;
      state.pendingVoucherCode = '';
      state.pendingVoucherExpiresAt = '';
      state.items = [];
      state.floatingTexts = [];
      state.lastSpawnedTypes = [];
      state.catchFlash = { active: false, x: 0, y: 0, timer: 0, color: '#166534', radius: 0 };
      state.screenShake = { active: false, intensity: 0, timer: 0 };
      state.bombFlash = { active: false, timer: 0 };
      state.spawnCooldown = 0.3;
      state.firstSpawnDone = false;

      claw.phase = CLAW_PHASES.IDLE;
      claw.x = state.canvasWidth * 0.5;
      claw.y = claw.startY;
      claw.dir = 1;
      claw.grabbingTimer = 0;
      claw.dropProgress = 0;
      claw.carrying = null;
      claw.pendingCatchResolution = null;

      safeSetText(els.finalScore, '0');
      if (els.newVoucher) els.newVoucher.hidden = true;
      updateScoreUI();
      updateGameTimerUI();
    }

    function updateFinalScreenValues() {
      safeSetText(els.finalScore, state.currentScore);
      safeSetText(els.finalHigh, state.highScore);
      safeSetText(els.finalTotal, state.rankingsScore);
      safeSetText(els.finalRankings, state.playerRank ? '#' + state.playerRank : '-');
      updateGameOverRewards();
    }

    function fmtPrice(cents) {
      var n = toIntOr(cents, 0);
      return '$' + (n / 100).toFixed(2);
    }

    function resetProductSelectionUI() {
      state.selectedProductVariantId = '';
      if (els.claimProductBtn) {
        els.claimProductBtn.disabled = true;
        els.claimProductBtn.textContent = 'CLAIM BAG';
      }
    }

    function fetchCollectionProducts() {
      var handle = String(config.voucherCollectionHandle || '').replace(/^\s+|\s+$/g, '');
      if (!handle) {
        state.productsCache = [];
        return Promise.resolve([]);
      }

      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', {
        method: 'GET',
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('products_fetch_failed');
          return res.json();
        })
        .then(function (data) {
          var products = (data && data.products) ? data.products : [];
          var mapped = [];
          var i;
          for (i = 0; i < products.length; i++) {
            var p = products[i] || {};
            var variants = p.variants || [];
            var variant = null;
            var v;
            for (v = 0; v < variants.length; v++) {
              if (variants[v] && variants[v].available) {
                variant = variants[v];
                break;
              }
            }
            if (!variant) continue;

            var priceCents = Math.round(parseFloat(variant.price || '0') * 100);
            if (isNaN(priceCents) || priceCents < 0) priceCents = 0;

            var imageSrc = '';
            if (p.images && p.images.length) {
              imageSrc = p.images[0].src || '';
            }

            mapped.push({
              id: p.id,
              variantId: variant.id,
              title: p.title || '',
              price: priceCents,
              img: imageSrc,
              handle: p.handle || ''
            });
          }

          state.productsCache = mapped;
          return mapped;
        })
        .catch(function () {
          state.productsCache = [];
          return [];
        });
    }

    function selectProductCard(card) {
      if (!els.productsGrid) return;
      var cards = els.productsGrid.querySelectorAll('.hc-eg2__product');
      Array.prototype.forEach.call(cards, function (c) {
        c.classList.remove('is-selected');
      });
      card.classList.add('is-selected');
      state.selectedProductVariantId = card.getAttribute('data-variant-id') || '';
      if (els.claimProductBtn) {
        els.claimProductBtn.disabled = !state.selectedProductVariantId;
        els.claimProductBtn.textContent = 'CLAIM BAG';
      }
    }

    function destroyProductsEmbla() {
      if (state.productsEmbla) {
        state.productsEmbla.destroy();
        state.productsEmbla = null;
      }
    }

    function updateProductsArrows() {
      if (!state.productsEmbla) return;
      if (els.productsPrev) els.productsPrev.disabled = !state.productsEmbla.canScrollPrev();
      if (els.productsNext) els.productsNext.disabled = !state.productsEmbla.canScrollNext();
    }

    function updateProductsDots() {
      if (!els.productsDots) return;
      var idx = state.productsEmbla ? state.productsEmbla.selectedScrollSnap() : 0;
      var dots = els.productsDots.querySelectorAll('.hc-eg2__products-dot');
      Array.prototype.forEach.call(dots, function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    function buildProductsDots() {
      if (!state.productsEmbla || !els.productsDots) return;
      var snaps = state.productsEmbla.scrollSnapList();
      els.productsDots.innerHTML = '';
      if (snaps.length <= 1) return;
      snaps.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hc-eg2__products-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to group ' + (i + 1));
        dot.addEventListener('click', function () { if (state.productsEmbla) state.productsEmbla.scrollTo(i); });
        els.productsDots.appendChild(dot);
      });
    }

    function initProductsCarousel() {
      destroyProductsEmbla();
      if (typeof EmblaCarousel === 'undefined' || !els.productsViewport) {
        if (els.productsViewport) {
          els.productsViewport.style.overflowX = 'auto';
          els.productsViewport.style.webkitOverflowScrolling = 'touch';
        }
        return;
      }

      state.productsEmbla = EmblaCarousel(els.productsViewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      state.productsEmbla.on('select', function () { updateProductsDots(); updateProductsArrows(); });
      state.productsEmbla.on('reInit', function () { buildProductsDots(); updateProductsArrows(); });

      buildProductsDots();
      updateProductsArrows();

      if (els.productsPrev && !els.productsPrev.__hcg2Bound) {
        els.productsPrev.__hcg2Bound = true;
        els.productsPrev.hidden = false;
        els.productsPrev.addEventListener('click', function () { if (state.productsEmbla) state.productsEmbla.scrollPrev(); });
      }
      if (els.productsNext && !els.productsNext.__hcg2Bound) {
        els.productsNext.__hcg2Bound = true;
        els.productsNext.hidden = false;
        els.productsNext.addEventListener('click', function () { if (state.productsEmbla) state.productsEmbla.scrollNext(); });
      }
    }

    var tabProductsCache = {};

    function fetchTabProducts(handle, callback) {
      if (!handle) { callback([]); return; }
      if (tabProductsCache[handle]) { callback(tabProductsCache[handle]); return; }
      fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', {
        method: 'GET',
        credentials: 'same-origin'
      })
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (data) {
          var products = (data && data.products) ? data.products : [];
          var mapped = products.reduce(function (acc, p) {
            var variant = null;
            var v;
            for (v = 0; v < (p.variants || []).length; v++) {
              if (p.variants[v] && p.variants[v].available) { variant = p.variants[v]; break; }
            }
            if (!variant) return acc;
            var priceCents = Math.round(parseFloat(variant.price || '0') * 100);
            acc.push({
              variantId: variant.id,
              title: p.title || '',
              price: isNaN(priceCents) ? 0 : priceCents,
              img: (p.images && p.images.length) ? p.images[0].src || '' : ''
            });
            return acc;
          }, []);
          tabProductsCache[handle] = mapped;
          callback(mapped);
        })
        .catch(function () { callback([]); });
    }

    function renderProductsGrid(products, discountPct, claimBtn, discountCode) {
      var grid = els.productsGrid;
      if (!grid) return;

      state.selectedProductVariantId = '';
      if (claimBtn) { claimBtn.disabled = true; claimBtn.textContent = 'CLAIM BAG'; }

      var pct = toIntOr(discountPct, 0);
      var html = '';
      var i;
      for (i = 0; i < products.length; i++) {
        var p = products[i];
        var discounted = Math.round(p.price * (1 - (pct / 100)));
        if (discounted < 0) discounted = 0;
        html += '<div class="hc-eg2__product" data-variant-id="' + String(p.variantId) + '" tabindex="0">';
        html += '<div class="hc-eg2__product-badge">' + String(pct) + '% OFF</div>';
        html += '<img class="hc-eg2__product-img" src="' + escapeHtml(p.img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
        html += '<div class="hc-eg2__product-info">';
        html += '<div class="hc-eg2__product-name">' + escapeHtml(p.title) + '</div>';
        html += '<div class="hc-eg2__product-prices">';
        html += '<span class="hc-eg2__product-old">' + fmtPrice(p.price) + '</span> ';
        html += '<span class="hc-eg2__product-new">' + fmtPrice(discounted) + '</span>';
        html += '</div></div></div>';
      }
      grid.innerHTML = html;
      initProductsCarousel();

      Array.prototype.forEach.call(grid.querySelectorAll('.hc-eg2__product'), function (card) {
        card.addEventListener('click', function () {
          Array.prototype.forEach.call(grid.querySelectorAll('.hc-eg2__product'), function (c) {
            c.classList.remove('is-selected');
          });
          card.classList.add('is-selected');
          state.selectedProductVariantId = card.getAttribute('data-variant-id') || '';
          if (claimBtn) { claimBtn.disabled = !state.selectedProductVariantId; }
        });
        card.addEventListener('keydown', function (event) {
          var key = event && (event.key || event.code || '');
          if (key === 'Enter' || key === ' ' || key === 'Space' || key === 'Spacebar') {
            if (event && event.preventDefault) event.preventDefault();
            card.click();
          }
        });
      });
    }

    function buildProductsTabBar(tabs, discountPct, claimBtn, discountCode) {
      var tabBar = els.productsTabs;
      if (!tabBar) return;
      tabBar.innerHTML = '';

      tabs.forEach(function (tab, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hc-eg2__products-tab' + (idx === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', String(idx === 0));
        btn.textContent = tab.label;
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-active')) return;
          Array.prototype.forEach.call(tabBar.querySelectorAll('.hc-eg2__products-tab'), function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
            b.disabled = false;
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          btn.disabled = true;
          fetchTabProducts(tab.handle, function (products) {
            btn.disabled = false;
            renderProductsGrid(products, discountPct, claimBtn, discountCode);
          });
        });
        tabBar.appendChild(btn);
      });

      fetchTabProducts(tabs[0].handle, function (products) {
        renderProductsGrid(products, discountPct, claimBtn, discountCode);
      });
    }

    function showCollectionProducts(discountCode, discountPct) {
      var wrap = els.productsSection;
      var claimBtn = els.claimProductBtn;
      var pct = toIntOr(discountPct, 0);
      var tabs = config.tabs || [];

      if (!wrap || !claimBtn) return;
      if (!tabs.length && !state.productsCache.length) { if (wrap) wrap.hidden = true; return; }

      wrap.hidden = false;
      state.selectedProductVariantId = '';
      claimBtn.disabled = true;
      claimBtn.textContent = 'CLAIM BAG';

      if (els.productsTitle) {
        els.productsTitle.textContent = 'SHOP WITH ' + String(pct) + '% OFF!';
      }

      if (els.productsCodeRow && els.productsCodeEl) {
        els.productsCodeEl.textContent = String(discountCode);
        els.productsCodeRow.hidden = false;
      }
      if (els.copyCodeBtn) {
        els.copyCodeBtn.onclick = function () {
          var code = String(discountCode);
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(function () {
              els.copyCodeBtn.textContent = 'COPIED!';
              setTimeout(function () { els.copyCodeBtn.textContent = 'COPY'; }, 1500);
            });
          } else {
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.style.cssText = 'position:fixed;left:-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            els.copyCodeBtn.textContent = 'COPIED!';
            setTimeout(function () { els.copyCodeBtn.textContent = 'COPY'; }, 1500);
          }
        };
      }

      claimBtn.onclick = function () {
        if (!state.selectedProductVariantId) return;
        claimBtn.disabled = true;
        claimBtn.textContent = 'Adding to cart...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(state.selectedProductVariantId), quantity: 1 })
        })
          .then(function (res) { if (!res.ok) throw new Error('cart_add_failed'); return res.json(); })
          .then(function () { window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout'; })
          .catch(function () { claimBtn.textContent = 'Error — try again'; claimBtn.disabled = false; });
      };

      if (tabs.length > 0) {
        buildProductsTabBar(tabs, pct, claimBtn, discountCode);
      } else {
        renderProductsGrid(state.productsCache, pct, claimBtn, discountCode);
      }

      window.setTimeout(function () {
        if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }

    function buildVoucherItemHtml(best) {
      var html = '<div class="hc-eg2__voucher-item">';
      html += '<p class="hc-eg2__voucher-line">' + escapeHtml(best.label) + ' DISCOUNT <strong>✓</strong></p>';
      html += '<button class="hc-eg2__btn hc-eg2__btn--claim hc-eg2__reward-claim" type="button" data-reward-tier="' + best.index + '">CLAIM</button>';
      html += '</div>';
      return html;
    }

    function buildRewardsHtml(tiers) {
      var best = tiers && tiers.length ? tiers[tiers.length - 1] : null;
      if (!best) return '';
      var note = config.voucherNote || '';
      var html = '<div class="hc-eg2__voucher-box">';
      html += '<div class="hc-eg2__voucher-header">';
      html += '<h3 class="hc-eg2__voucher-title">Your Rewards</h3>';
      if (note) {
        html += '<div class="hc-eg2__voucher-note">' + escapeHtml(note).replace(/\n/g, '<br>') + '</div>';
      }
      html += '</div>';
      html += '<div class="hc-eg2__voucher-list">' + buildVoucherItemHtml(best) + '</div>';
      html += '</div>';
      return html;
    }

    function buildGameOverRewardsHtml(tiers) {
      var best = tiers && tiers.length ? tiers[tiers.length - 1] : null;
      if (!best) return '';
      return '<div class="hc-eg2__voucher-list">' + buildVoucherItemHtml(best) + '</div>';
    }

    function attachRewardClaimHandlers(container) {
      Array.prototype.forEach.call(container.querySelectorAll('[data-reward-tier]'), function (btn) {
        btn.addEventListener('click', function () {
          var tierIndex = toIntOr(btn.getAttribute('data-reward-tier'), 0);
          var matched = null;
          var j;
          for (j = 0; j < voucherTiers.length; j++) {
            if (voucherTiers[j].index === tierIndex) { matched = voucherTiers[j]; break; }
          }
          if (matched) {
            btn.textContent = '✓ CLAIMED';
            btn.disabled = true;
            btn.classList.add('is-claimed');
            openShopForTier(matched);
          }
        });
      });
    }

    function updatePregameBestReward() {
      if (!els.rewardsList) return;
      var tiers = getAllAchievedTiers(state.highScore);
      if (!tiers.length) {
        els.rewardsList.hidden = true;
        els.rewardsList.innerHTML = '';
        return;
      }
      els.rewardsList.innerHTML = buildRewardsHtml(tiers);
      els.rewardsList.hidden = false;
      attachRewardClaimHandlers(els.rewardsList);
    }

    function updateGameOverRewards() {
      if (!els.goRewardsList) return;
      var tiers = getAllAchievedTiers(state.highScore);
      if (!tiers.length) {
        if (els.goRewardsWrap) els.goRewardsWrap.hidden = true;
        els.goRewardsList.innerHTML = '';
        return;
      }
      els.goRewardsList.innerHTML = buildGameOverRewardsHtml(tiers);
      if (els.goRewardsWrap) els.goRewardsWrap.hidden = false;
      attachRewardClaimHandlers(els.goRewardsList);
    }

    function openShopForTier(tier) {
      if (!tier || !tier.code) {
        showTransientMessage('Try again to unlock rewards!');
        return;
      }

      state.selectedDiscountCode = tier.code;
      state.selectedDiscountPercent = tier.discountPercent;

      var discountReq = fetch('/discount/' + encodeURIComponent(tier.code), {
        method: 'GET',
        credentials: 'same-origin'
      }).catch(function () {});

      var productsReq = state.productsCache.length > 0
        ? Promise.resolve(state.productsCache)
        : fetchCollectionProducts();

      Promise.all([discountReq, productsReq])
        .then(function () {
          showCollectionProducts(tier.code, tier.discountPercent);
        })
        .catch(function () {
          showCollectionProducts(tier.code, tier.discountPercent);
        });
    }

    function makeApiUrl(path) {
      if (!config.workersUrl) return '';
      var base = config.workersUrl.replace(/\/$/, '');
      return base + path;
    }

    function apiFetch(path, options) {
      var url = makeApiUrl(path);
      if (!url) {
        return Promise.reject(new Error('Workers URL missing'));
      }
      return fetch(url, options);
    }

    function parseJsonSafe(res) {
      return res.text().then(function (txt) {
        if (!txt) return {};
        try {
          return JSON.parse(txt);
        } catch (e) {
          return {};
        }
      });
    }

    function apiRegister(email, name) {
      return apiFetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, name: name })
      }).then(function (res) {
        if (!res.ok) throw new Error('register_failed');
        return parseJsonSafe(res);
      });
    }

    function apiSubmitScore(token, finalScore, timestamp, gameHash) {
      return apiFetch('/api/score', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: token,
          final_score: finalScore,
          timestamp: timestamp,
          game_hash: gameHash
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('score_failed');
        return parseJsonSafe(res);
      });
    }

    function apiLeaderboard(token) {
      var query = token ? ('?token=' + encodeURIComponent(token)) : '';
      return apiFetch('/api/leaderboard' + query, {
        method: 'GET'
      }).then(function (res) {
        if (!res.ok) throw new Error('leaderboard_failed');
        return parseJsonSafe(res);
      });
    }

    function fallbackHash(str) {
      var h = 2166136261;
      var i;
      for (i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
      }
      var hex = '';
      var n = h >>> 0;
      hex = n.toString(16);
      while (hex.length < 8) hex = '0' + hex;
      return hex + hex + hex + hex + hex + hex + hex + hex;
    }

    function computeGameHash(score, timestamp) {
      var secret = 'egg-race-2026';
      var payload = score + ':' + timestamp + ':' + secret;

      if (!window.crypto || !crypto.subtle || !window.TextEncoder) {
        return Promise.resolve(fallbackHash(payload));
      }

      try {
        var data = new TextEncoder().encode(payload);
        return crypto.subtle.digest('SHA-256', data).then(function (hash) {
          var arr = new Uint8Array(hash);
          var out = '';
          var i;
          for (i = 0; i < arr.length; i++) {
            var hex = arr[i].toString(16);
            if (hex.length < 2) hex = '0' + hex;
            out += hex;
          }
          return out;
        });
      } catch (e) {
        return Promise.resolve(fallbackHash(payload));
      }
    }

    function applyDebugScoreOverride() {
      if (config.debug === 'force_score_500') {
        state.currentScore = 500;
      }
    }

    function fireConfetti() {
      if (typeof window.confetti !== 'function') return;
      window.confetti({
        particleCount: 60,
        spread: 55,
        startVelocity: 35,
        origin: { y: 0.7 },
        zIndex: 9999,
        colors: ['#a9894c', '#f8f4e8', '#ffffff', '#020303']
      });
      setTimeout(function () {
        window.confetti({
          particleCount: 40,
          spread: 70,
          startVelocity: 30,
          origin: { x: 0.3, y: 0.7 },
          zIndex: 9999,
          colors: ['#a9894c', '#f8f4e8', '#ffffff']
        });
      }, 300);
      setTimeout(function () {
        window.confetti({
          particleCount: 40,
          spread: 70,
          startVelocity: 30,
          origin: { x: 0.7, y: 0.7 },
          zIndex: 9999,
          colors: ['#a9894c', '#f8f4e8', '#ffffff']
        });
      }, 500);
    }

    function triggerGameOver(reason) {
      if ((!state.gameRunning && reason !== 'bomb') || state.gameOverTriggered) return;
      state.gameOverTriggered = true;
      state.gameRunning = false;

      applyDebugScoreOverride();

      var previousHighScore = state.highScore;
      if (state.currentScore > state.highScore) {
        state.highScore = state.currentScore;
        persistHighScore();
      }
      state.pendingVoucherTier = getCurrentBestTier(state.highScore);
      state.newlyUnlockedTier = getNewlyUnlockedTier(previousHighScore, state.highScore);

      updateScoreUI();
      updateFinalScreenValues();
      updatePregameBestReward();
      setAppState(STATES.GAME_OVER);

      if (state.newlyUnlockedTier && state.newlyUnlockedTier.discountPercent >= 45) {
        fireConfetti();
      }

      var timestamp = Math.floor(Date.now() / 1000);
      var token = state.playerToken;

      computeGameHash(state.currentScore, timestamp)
        .then(function (hash) {
          if (!token) throw new Error('missing_token');
          return apiSubmitScore(token, state.currentScore, timestamp, hash);
        })
        .then(function (data) {
          if (typeof data.high_score === 'number') {
            state.highScore = data.high_score;
            persistHighScore();
          }
          if (typeof data.rankings_score === 'number') {
            state.rankingsScore = data.rankings_score;
            persistRankingsScore();
          }
          return apiLeaderboard(token).then(function (lb) {
            if (lb && lb.player && typeof lb.player.rank === 'number') {
              state.playerRank = lb.player.rank;
            }
          }).catch(function () {});
        })
        .catch(function () {
          showTransientMessage('Offline mode: score saved locally');
        })
        .then(function () {
          state.pendingVoucherTier = getCurrentBestTier(state.highScore);
          loadLeaderboard();
          updateFinalScreenValues();
          updateScoreUI();
          updatePregameBestReward();
          debugLog('Game over reason:', reason, 'score:', state.currentScore);
        });
    }

    function startGame() {
      resetRoundValues();
      setAppState(STATES.PLAYING);

      startCountdown(function () {
        state.gameRunning = true;
        state.gameOverTriggered = false;
        if (els.tapHint) {
          els.tapHint.textContent = 'Tap / Click / Space to drop claw';
        }
      });
    }

    function updateGameTimer(dt) {
      if (!state.gameRunning) return;
      state.gameRemaining -= dt;
      if (state.gameRemaining <= 0) {
        state.gameRemaining = 0;
        updateGameTimerUI();
        triggerGameOver('time');
        return;
      }
      updateGameTimerUI();
    }

    function animateScoreCounter(dt) {
      var target = state.currentScore;
      var speed = 240;
      if (state.displayScore < target) {
        state.displayScore += speed * dt;
        if (state.displayScore > target) state.displayScore = target;
      } else if (state.displayScore > target) {
        state.displayScore -= speed * dt;
        if (state.displayScore < target) state.displayScore = target;
      }
      updateScoreUI();
    }

    function gameLoop(ts) {
      if (!state.lastFrameTime) {
        state.lastFrameTime = ts;
      }
      var dt = (ts - state.lastFrameTime) / 1000;
      if (dt > 0.05) dt = 0.05;
      if (dt < 0) dt = 0;
      state.lastFrameTime = ts;
      state.nowMs = ts;

      updateCatchFlash(dt);
      updateScreenShake(dt);

      var shakeX = 0;
      var shakeY = 0;
      if (state.screenShake.active) {
        shakeX = (Math.random() - 0.5) * state.screenShake.intensity * 2;
        shakeY = (Math.random() - 0.5) * state.screenShake.intensity * 2;
        state.screenShake.intensity *= 0.92;
      }

      ctx.save();
      ctx.translate(shakeX, shakeY);

      drawBackground();

      if (state.gameRunning) {
        updateItems(dt);
        updateClaw(dt);
        updateGameTimer(dt);
      }

      updateFloatingTexts(dt);
      animateScoreCounter(dt);

      drawItems();
      drawCatchFlash();
      drawClaw();
      drawFloatingTexts();

      ctx.restore();

      if (state.bombFlash.active) {
        state.bombFlash.timer -= dt;
        var bombAlpha = clamp(state.bombFlash.timer / 0.5, 0, 1) * 0.35;
        if (bombAlpha > 0) {
          ctx.fillStyle = 'rgba(204, 0, 0, ' + bombAlpha + ')';
          ctx.fillRect(0, 0, state.canvasWidth, state.canvasHeight);
        }
        if (state.bombFlash.timer <= 0) state.bombFlash.active = false;
      }

      state.rafId = requestAnimationFrame(gameLoop);
    }

    function maskName(name) {
      var s = String(name || '').replace(/^\s+|\s+$/g, '');
      if (!s) return 'Anonymous';
      if (s.length <= 3) return s + '***';
      return s.substring(0, 3) + '***';
    }

    function maskEmail(email) {
      var s = String(email || '').replace(/^\s+|\s+$/g, '');
      if (!s || !s.includes('@')) return '—';
      var parts = s.split('@');
      var local = parts[0];
      var domain = parts[1];
      var localMasked = local.length <= 3 ? local : local.substring(0, 3);
      var domainMasked = domain.length <= 1 ? domain : domain.substring(0, 1) + '...';
      return localMasked + '...@' + domainMasked;
    }

    function renderLeaderboard(data) {
      if (!els.lbList) return;

      if (!data || !Array.isArray(data.top10)) {
        els.lbList.innerHTML = '<li class="hc-eg2__lb-row hc-eg2__lb-row--empty"><span colspan="4">Unable to load leaderboard.</span></li>';
        if (els.lbPlayer) els.lbPlayer.hidden = true;
        if (els.lbNote) els.lbNote.textContent = 'Unable to load. Please try again.';
        return;
      }
      if (!data.top10.length) {
        els.lbList.innerHTML = '<li class="hc-eg2__lb-row hc-eg2__lb-row--empty"><span>Be the first to play!</span></li>';
        if (els.lbPlayer) els.lbPlayer.hidden = true;
        if (els.lbNote) els.lbNote.textContent = '';
        return;
      }

      var player = (data && data.player && data.player.rankings_score > 0) ? data.player : null;
      var playerRank = player ? toIntOr(player.rank, 0) : 0;
      var playerInTop10 = false;
      var html = '';
      var i;

      html += '<li class="hc-eg2__lb-row hc-eg2__lb-row--header">';
      html += '<span class="hc-eg2__lb-rank">Rank</span>';
      html += '<strong class="hc-eg2__lb-name">Name</strong>';
      html += '<span class="hc-eg2__lb-email">Email</span>';
      html += '<em class="hc-eg2__lb-score">Points</em>';
      html += '</li>';

      for (i = 0; i < data.top10.length; i++) {
        var row = data.top10[i] || {};
        var isCurrent = player && playerRank > 0 && (i + 1) === playerRank;
        if (isCurrent) playerInTop10 = true;
        var rankMedal = i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : '#' + (i + 1);
        html += '<li class="hc-eg2__lb-row' + (isCurrent ? ' is-current-player' : '') + '">';
        html += '<span class="hc-eg2__lb-rank">' + rankMedal + '</span>';
        html += '<strong class="hc-eg2__lb-name">' + escapeHtml(maskName(row.name)) + (isCurrent ? ' (You)' : '') + '</strong>';
        html += '<span class="hc-eg2__lb-email">' + escapeHtml(maskEmail(row.email)) + '</span>';
        html += '<em class="hc-eg2__lb-score">' + escapeHtml(String(row.rankings_score || 0)) + '</em>';
        html += '</li>';
      }

      if (player && !playerInTop10) {
        html += '<li class="hc-eg2__lb-row hc-eg2__lb-row--sep" aria-hidden="true"><span>•••</span><span></span><span></span><span></span></li>';
        html += '<li class="hc-eg2__lb-row is-current-player">';
        html += '<span class="hc-eg2__lb-rank">#' + escapeHtml(String(player.rank || '-')) + '</span>';
        html += '<strong class="hc-eg2__lb-name">' + escapeHtml(maskName(player.name || state.playerName)) + ' (You)</strong>';
        html += '<span class="hc-eg2__lb-email">' + escapeHtml(maskEmail(player.email || state.playerEmail)) + '</span>';
        html += '<em class="hc-eg2__lb-score">' + escapeHtml(String(player.rankings_score || 0)) + '</em>';
        html += '</li>';
      }

      els.lbList.innerHTML = html;

      if (els.lbPlayer) els.lbPlayer.hidden = true;

      if (els.lbNote) {
        if (player) {
          var top10count = data.top10.length;
          if (playerInTop10) {
            els.lbNote.textContent = 'You\'re in the Top 10! Keep playing to hold your spot.';
            els.lbNote.className = 'hc-eg2__lb-note hc-eg2__lb-note--good';
          } else if (top10count >= 10) {
            var cutoff = toIntOr((data.top10[top10count - 1] || {}).rankings_score, 0);
            var gap = cutoff - toIntOr(player.rankings_score, 0) + 1;
            els.lbNote.textContent = gap + ' point' + (gap === 1 ? '' : 's') + ' away from Top 10 — keep playing!';
            els.lbNote.className = 'hc-eg2__lb-note hc-eg2__lb-note--chase';
          } else {
            els.lbNote.textContent = 'Play more to climb the leaderboard!';
            els.lbNote.className = 'hc-eg2__lb-note';
          }
        } else {
          els.lbNote.textContent = '';
          els.lbNote.className = 'hc-eg2__lb-note';
        }
      }
    }

    function loadLeaderboard() {
      if (!els.lbList) return;
      if (els.lbNote) els.lbNote.textContent = 'Loading...';

      apiLeaderboard(state.playerToken)
        .then(function (data) {
          renderLeaderboard(data);
          state.leaderboardLoaded = true;
        })
        .catch(function () {
          renderLeaderboard(null);
        });
    }

    function openLeaderboard() {
      loadLeaderboard();
    }

    function validateEmail(value) {
      if (!value) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function handleEmailSubmit(e) {
      if (e && e.preventDefault) e.preventDefault();
      if (!els.nameInput || !els.emailInput) return;

      var name = (els.nameInput.value || '').replace(/^\s+|\s+$/g, '');
      var email = (els.emailInput.value || '').replace(/^\s+|\s+$/g, '').toLowerCase();

      if (!name || name.length < 2) {
        showTransientMessage('Please enter your name');
        return;
      }
      if (!validateEmail(email)) {
        showTransientMessage('Please enter a valid email');
        return;
      }

      if (els.emailSubmit) els.emailSubmit.disabled = true;

      apiRegister(email, name)
        .then(function (data) {
          if (data && data.token) {
            state.playerToken = data.token;
            state.playerName = name;
            state.playerEmail = email;
            safeStorageSet(STORAGE_KEYS.TOKEN, data.token);
            safeStorageSet(STORAGE_KEYS.NAME, name);
            safeStorageSet(STORAGE_KEYS.EMAIL, email);
          }
          setAppState(STATES.PRE_GAME);
          loadLeaderboard();
        })
        .catch(function () {
          state.playerName = name;
          state.playerEmail = email;
          safeStorageSet(STORAGE_KEYS.NAME, name);
          safeStorageSet(STORAGE_KEYS.EMAIL, email);
          showTransientMessage('Offline mode enabled');
          setAppState(STATES.PRE_GAME);
          loadLeaderboard();
        })
        .then(function () {
          if (els.emailSubmit) els.emailSubmit.disabled = false;
        });
    }

    function setupEmailGateHandler() {
      if (!els.emailForm) return;
      els.emailForm.addEventListener('submit', handleEmailSubmit);
    }

    function setupPregameHandler() {
    }

    function setupOverlayHandlers() {
      if (els.canvasStartBtn) {
        els.canvasStartBtn.addEventListener('click', function () {
          startGame();
        });
      }

      if (els.canvasRetryBtn) {
        els.canvasRetryBtn.addEventListener('click', function () {
          startGame();
        });
      }
    }

    function setupGameOverHandler() {
      if (els.retryBtn) {
        els.retryBtn.addEventListener('click', function () {
          startGame();
        });
      }

      if (els.goMenuBtn) {
        els.goMenuBtn.addEventListener('click', function () {
          setAppState(STATES.PRE_GAME);
        });
      }
    }

    function handleCanvasPointerDown(e) {
      if (e && e.preventDefault) e.preventDefault();
      dropClaw();
    }

    function handleKeyDown(e) {
      var key = e && (e.key || e.code || '');
      if (key === ' ' || key === 'Space' || key === 'Spacebar') {
        if (e && e.preventDefault) e.preventDefault();
        dropClaw();
      }
    }

    function setupInputListeners() {
      els.canvas.addEventListener('pointerdown', handleCanvasPointerDown);
      els.canvas.addEventListener('click', handleCanvasPointerDown);
      document.addEventListener('keydown', handleKeyDown);
    }

    function bootstrapSprites(done) {
      preloadSprites({
        claw: config.clawSprite,
        egg: config.eggSprite,
        gift: config.giftSprite,
        bomb: config.bombSprite,
        bg: config.bgImage
      }, function (sprites) {
        state.sprites = sprites || {};
        done();
      });
    }

    function initFlowState() {
      if (state.playerToken) {
        setAppState(STATES.PRE_GAME);
        openLeaderboard();
      } else {
        setAppState(STATES.EMAIL_GATE);
      }
    }

    function initLoop() {
      if (state.rafId) cancelAnimationFrame(state.rafId);
      state.lastFrameTime = 0;
      state.rafId = requestAnimationFrame(gameLoop);
    }

    function init() {
      loadStorage();
      setupCanvasSize();
      setupResizeObserver();
      updateScoreUI();
      if (state.playerToken) updatePregameBestReward();
      updateGameTimerUI();
      fetchCollectionProducts().then(function () {});
      setupEmailGateHandler();
      setupPregameHandler();
      setupGameOverHandler();
      setupOverlayHandlers();
      setupInputListeners();

      if (els.nameInput && !els.nameInput.value && state.playerName) {
        els.nameInput.value = state.playerName;
      }
      if (els.emailInput && !els.emailInput.value && state.playerEmail) {
        els.emailInput.value = state.playerEmail;
      }

      bootstrapSprites(function () {
        resetRoundValues();
        initFlowState();
        initLoop();
      });
    }

    init();
  });
})();
